var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.remark)?_c('span',[_vm._v("("+_vm._s(_vm.customRemark || _vm.$t(`contacts.form.${_vm.remark.toLowerCase()}OptionLabel`))+")")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }